import {
  GET_CMS_IMAGE_LINKS_FOOTER,
  GET_CMS_TEXT_LINKS_FOOTER,
  GET_CMS_LOGO_SITIO_WEB_FOOTER,
} from "./types";
import CMSService from "../../services/cms.service";

export function getImageLinksFooter(token) {
  return function (dispatch) {
    try {
      return CMSService.reqImageLinksFooter(token).then((data) => {
        dispatch({
          type: GET_CMS_IMAGE_LINKS_FOOTER,
          payload: data,
        });
      });
    } catch (error) {
      return (dispatch) => {
        dispatch({
          type: GET_CMS_IMAGE_LINKS_FOOTER,
          payload: null
        });
      };
    }
  };
}

export function getTextLinksFooter(token) {
  return function (dispatch) {
    try {
      return CMSService.reqTextLinksFooter(token).then((data) => {
        dispatch({
          type: GET_CMS_TEXT_LINKS_FOOTER,
          payload: data,
        });
      });
    } catch (error) {
      return (dispatch) => {
        dispatch({
          type: GET_CMS_TEXT_LINKS_FOOTER,
          payload: null
        });
      };
    }
  };
}

export function getLogoSitioWebFooter(token) {
  return function (dispatch) {
    try {
      return CMSService.reqLogoSitioWebFooter(token).then((data) => {
        dispatch({
          type: GET_CMS_LOGO_SITIO_WEB_FOOTER,
          payload: data,
        });
      });
    } catch (error) {
      return (dispatch) => {
        dispatch({
          type: GET_CMS_LOGO_SITIO_WEB_FOOTER,
          payload: null,
        });
      };
    }
  };
}
